import { css } from '@emotion/react'
import { Alert, Button, Cell, Grid, Modal, ModalBody, ModalHeader, Text, TextInput, VFlow } from 'bold-ui'
import { Divider } from 'components/divider/Divider'
import {
  AlertVideochamadaType,
  compartilharChamadaAlertRecord,
  CompartilharVideochamadaAlertData,
} from 'components/videochamada'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router'

import { VideochamadaUrlParams } from '../model-videochamada'
import { EnviarEmailVideochamadaForm } from './EnviarEmailVideochamadaForm'

//TODO (RNG): Verificar se é possível usar CompartilharVideochamadaForm (#14543)
interface CompartilharChamadaModalProps {
  open: boolean
  onClose(): void
}

export function CompartilharChamadaModal({ onClose, open }: CompartilharChamadaModalProps) {
  const { analytics } = useAnalytics()

  const {
    params: { uuid: videochamadaUuid },
  } = useRouteMatch<VideochamadaUrlParams>()

  const url = `${window.location.origin}/videochamada/${videochamadaUuid}`

  const [compartilharVideochamadaAlertData, setCompartilharVideochamadaAlertData] = useState<
    CompartilharVideochamadaAlertData
  >()

  useEffect(() => {
    !open && setCompartilharVideochamadaAlertData(null)
  }, [open])

  const handleCopiarLinkClick = () => {
    analytics.logEvent('TELE_videochamadas_copia_link')
    navigator.clipboard.writeText(url)
    setCompartilharVideochamadaAlertData(compartilharChamadaAlertRecord[AlertVideochamadaType.LINK_COMPARTILHADO])
  }

  const handleSubmitSucceeded = () => {
    setCompartilharVideochamadaAlertData(compartilharChamadaAlertRecord[AlertVideochamadaType.ENVIO_EMAIL_SUCESSO])
  }

  const handleSubmitFailed = () => {
    setCompartilharVideochamadaAlertData(compartilharChamadaAlertRecord[AlertVideochamadaType.ENVIO_EMAIL_ERRO])
  }

  return (
    <Modal open={open} onClose={onClose} size='small'>
      <ModalHeader title='Compartilhar chamada' icon={{ name: 'infoCircleOutline', fill: 'primary' }} />
      <ModalBody>
        <VFlow vSpacing={0.5}>
          <VFlow
            style={css`
              height: 2.5rem;
            `}
          >
            {compartilharVideochamadaAlertData && (
              <Alert type={compartilharVideochamadaAlertData.type}>{compartilharVideochamadaAlertData.message}</Alert>
            )}
          </VFlow>
          <Text>
            Para compartilhar a chamada, é possível copiar o link e enviar para convidados de dentro ou de fora do e-SUS
            APS.
          </Text>
          <Grid alignItems='center' gap={0.5}>
            <Cell flexGrow={1}>
              <TextInput disabled value={url} aria-hidden data-testid='TextInput.CompartilharChamada' />
            </Cell>
            <Cell>
              <Button onClick={handleCopiarLinkClick} kind='primary' size='small' aria-label='Copiar link'>
                Copiar
              </Button>
            </Cell>
          </Grid>
          <Divider
            style={css`
              margin: 0.5rem 0;
            `}
          />
          <EnviarEmailVideochamadaForm
            videochamadaUuid={videochamadaUuid}
            handleSubmitSucceeded={handleSubmitSucceeded}
            handleSubmitFailed={handleSubmitFailed}
          />
        </VFlow>
      </ModalBody>
    </Modal>
  )
}
